import React from "react";
import DOMPurify from "dompurify";
import ScrollAnimation from 'react-animate-on-scroll';
import Form from "../forms/form";
import MyCountdown from "../parts/countdown";

import 'animate.css';


function  BusinessStats() {

    return (
        <section className="py-[60px] lg:py-[120px] bg-[#faf9ff]">

            <div className="container max-w-[1340px] mx-auto px-5">

                <div className="md:grid md:grid-cols-2 gap-[clamp(32px,calc(32px+48*((100vw-390px)/1530)),80px)]">
                    <div className="mb-6 md:mb-0">
                        <h2 className="uppercase leading-[1.2] font-extrabold mb-4 xl:mb-[26px]
                            text-[clamp(24px,calc(24px+26*((100vw-390px)/1530)),50px)]">У бізнесі не всі відповіді потрібно шукати самостійно</h2>
                        <p className="leading-[1.2] text-base lg:text-lg md:mb-[30px]">
                            <strong>GET Business FEST</strong> створює простір, де досвід підприємців не залишається всередині окремих компаній. Приєднуйтесь до GET Business FEST, щоб побачити за цифрами реальні бізнес-кейси, рішення та досвід, які можна переосмислити для власної стратегії.
                        </p>
                        <div className="hidden md:block bisnes-form py-6 px-[15px] bg-white border border-[#babafe] rounded-tr-[100px]
                            lg:p-[40px]">
                            <MyCountdown/>
                            <Form/>
                        </div>
                    </div>

                    <div className="grid gap-[15px] xl:gap-[20px] mb-[35px] md:mb-0">
                        <div className="py-[25px] px-[20px] bg-[#babafe] xl:px-[50] xl:py-[20px] rounded-tr-[150px]">
                            <h3 className="text-[54px] font-bold uppercase leading-[1.2] mb-1 
                                xl:text-[60px]">63%</h3>
                            <p className="text-base font-semibold leading-[1.2] xl:text-[18px] xl:max-w-[430px]">підприємців, які планують зростання, хочуть розширити клієнтську базу</p>
                        </div>
                        <div className="py-[25px] px-[20px] bg-[#babafe] xl:px-[50] xl:py-[20px]"> 
                            <h3 className="text-[54px] font-bold uppercase leading-[1.2] mb-1
                                xl:text-[60px]">59%</h3>
                            <p className="text-base font-semibold leading-[1.2] xl:text-[18px] xl:max-w-[430px]">підприємців потребують довгострокового фінансування для розвитку</p>
                        </div>
                        <div className="py-[25px] px-[20px] bg-[#babafe] xl:px-[50] xl:py-[20px]  rounded-tr-[150px]">
                            <h3 className="text-[54px] font-bold uppercase leading-[1.2] mb-1 
                                xl:text-[60px]">74%</h3>
                            <p className="text-base font-semibold leading-[1.2] xl:text-[18px] xl:max-w-[430px]">компаній називають дефіцит кваліфікованих кадрів значним викликом</p>
                        </div>
                        <div className="py-[25px] px-[20px] bg-[#babafe] xl:px-[50] xl:py-[20px]">
                            <h3 className="text-[54px] font-bold uppercase leading-[1.2] mb-1
                                xl:text-[60px]">28%</h3>
                            <p className="text-base font-semibold leading-[1.2] xl:text-[18px] xl:max-w-[430px]">українських компаній уже працюють на зовнішніх ринках</p>
                        </div>
                    </div>
                </div>


                <div className="md:hidden bisnes-form py-6 px-[15px] bg-white border border-[#babafe] rounded-tr-[100px]">
                    <MyCountdown/>
                    <Form/>
                </div>

                <div className="mt-8 md:mt-10 rounded-tr-[42px] border border-[#babafe] bg-white px-5 py-5 sm:px-6 sm:py-6">
                    <div className="mb-3 flex items-center gap-3">
                        <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#babafe] text-[#27275f]" aria-hidden="true">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="none"
                                className="h-5 w-5"
                                stroke="currentColor"
                                strokeWidth="2"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 21s7-5.33 7-11a7 7 0 1 0-14 0c0 5.67 7 11 7 11Z" />
                                <circle cx="12" cy="10" r="2.5" />
                            </svg>
                        </span>
                        <p className="text-[20px] font-extrabold uppercase leading-[1.2] text-[#27275f]">Secret Place</p>
                    </div>

                    <p className="max-w-[840px] text-[15px] leading-[1.5] text-[#26264d] sm:text-base">
                        Задля вашої безпеки місце проведення повідомимо учасникам напередодні заходу. У випадку
                        повітряної тривоги на локації є укриття.
                    </p>
                </div>

            </div>

        </section>
    )
}

export default BusinessStats;